export default {
  'gooticsMonthly': {
    plan: 'gooticsMonthly',
    description: '1 month gootics for $ 5',
    amount: '500',
    type: 'subscription'
  },
  'gooticsYearly': {
    plan: 'gooticsYearly',
    description: '1 year gootics for only 8c / day',
    amount: '2900',
    type: 'subscription'
  },
  'gooticsLifetime': {
    plan: 'gooticsLifetime',
    description: 'A lifetime of gootics for $ 89',
    amount: '8900',
    type: 'charge'
  }
}



// WEBPACK FOOTER //
// ./src/components/modules/subscription.js